<template>
    <!-- 首页 -->
    <div v-if="majorArrData">
        <!--<div id="Div1" style="display: none"><img id="Img1" width="100%" src="../assets/logo.png" style="position: absolute; top: 0; left: 0;"></div>-->
        <majorChoice :data="majorArrData" @major-change="MajorChange"></majorChoice>
        <div class="swipe-container">
        <mt-swipe class="banner" :auto="4000">
            <mt-swipe-item v-for="(item, i) of banner" :key="i" >
                <img :src="item.file_path" alt="" @click="news(item.article_url,item.file_path)">
            </mt-swipe-item>
        </mt-swipe>
        </div>
        <div class="container">

            <hotlivelist :data="hotlive" :list="hotlive.list" ></hotlivelist>

            <category v-for="(item, i) in category" :data="item" :key="Math.random()" ></category>

            <div class="indexBook">
                <div class="connerwidth boxSizing category">
                    <p class="title">
                        <span class="iconfont icon-ai-book"></span>
                        <em>必读好书</em>
                    </p>
                    <ul>
                        <li v-for="(item,i) of bookFeature" :key="i">
                            <router-link :to="'/shopdel?id=' + item.id">
                                <goodBook :data="item"></goodBook>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer">
							<!-- <router-link to="http://app.hxwomi.com/download">立即下载</router-link> -->
                <a href="http://app.hxwomi.com/download">打开APP，查看更多精彩内容 ></a>
                <p style="padding: 0 40px;line-height: 20px;">版权所有 ©京ICP备18047046号-1 2018 华夏沃米(北京)教育科技有限公司</p>
            </div>
            <footerDownload></footerDownload>
        </div>
    </div>
</template>

<script>
import category from "../components/index/category";
import hotlivelist from "../components/index/hotlivelist";
import majorChoice from "../components/globe/majorChoice";
import goodBook from "../components/index/goodBook";
import footerDownload from "../components/globe/footerDownload";
import axios from "axios";
import qs from "qs";

export default {
  name: "indexs",
  mounted() {

      /**根据系统做兼容性判断 */
      if((localStorage.getItem("IsPayStatuCodeByH5") === "1")){

          let path = localStorage.getItem("RedirectPath");
          localStorage.removeItem("RedirectPath");
          if(path){
            window.location.href = path;
          }
      }

      //此处是嵌入公众号时初始化专业   例如会计557
      if(localStorage.getItem('categoryId')){
          let param = { subject: localStorage.getItem('categoryId') };
          this.GetIndexData(param);
      }else{
          let param = { subject: '557' };
          this.GetIndexData(param);
      }

    // majorChange('557','初级会计职称考试');
  },
  data() {
    return {
      majorArrData: "",
      hotlive:{
          title:"热门直播",
          iconClass: "icon-ai-video",
          list: {},
          detailsName: "hotvideo"
      },

      category: [
        {
          title: "精讲课程",
          iconClass: "icon-ai-video",
          ajaxData: {},
          detailsName: "bookvideo"
        }
      //   {
      //     title: "天天听书",
      //     iconClass: "icon-tianchongxing-",
      //     ajaxData: {},
      //     detailsName: "address"
      //   },
      //   {
      //     title: "电子书",
      //     iconClass: "icon-ai-book",
      //     ajaxData: {}
      //   }
      ],
      banner: ""
    };
  },
  methods: {
      //导航修改是触发的事件
      MajorChange(id, name){
          localStorage.setItem("categoryId", id);
          localStorage.setItem("category", name);
          this.GetIndexData({ subject: id });
      },
      //获取页面数据
      GetIndexData(obj){
          let param = obj || { subject: localStorage.getItem('categoryId') };

          param && axios.post("/wap/Base/index", qs.stringify(param)).then(data => {

              let res = data.data;
              console.log(res);
              this.majorArrData = res.data.categorys;  //这是顶部导航的数据
              this.hotlive.list = res.data.liveFeature;
              this.category[0].ajaxData = res.data.videoFeature;   //这里是精讲课程的业务逻辑
              this.bookFeature = res.data.bookFeature;
              this.banner = res.data.tops;

              //this.category[1].ajaxData = data.liveFeature;   //这里增加直播的逻辑
              //this.category[1].ajaxData = data.broadFeature;
              //this.category[2].ajaxData = data.ebookFeature;
          });
      },
      toshopDel (id) {
          this.$router.push({ path: '/shopdel', query: { id:id } });
      },
      //点击banner图进入资讯页面
      news (url,path) {
        if(path === "http://file.wm319.com/public/images/1a4183406cfe43719e7a1f620c833293.jpg"){
          this.$router.push({path:'/poster'});
        }else{
          location.href = 'http://wap.wm319.com' + url;
        }
      },

  },
  components: {
    hotlivelist,
    category,
    goodBook,
    majorChoice,
    footerDownload
  }
};
</script>

<style scoped lang="scss">
.swipe-container{
  position: relative;
  top: 0.9rem;
  margin-bottom: 0.9rem;
}
.footer {
  padding: 88px 0 72px 0;
  background: #fff;
  font-size: 0;
  text-align: center;
  a {
    border-radius: 800px;
    font-size: 36px;
    color: #ff7f02;
    margin: 0 auto 20px;
    line-height: 1;
    border: 1PX solid #ff7f02;
    padding: 23px 60px;
    display: inline-block;
  }
  p {
    font-size: 26px;
    line-height: 1;
    color: #999;
    text-align: center;
  }
}
.banner {
  width: 100%;
  height: 306px;
  /deep/ .mint-swipe-item {
    /*background: #eb7d84;*/
      img{
          width: 100%;
          height: 100%;
      }
  }
}
.container {
  background: #f6f7f8;
  padding-bottom: 1PX;
}
.connerwidth {
  width: 100%;
  padding: 0 30px;
  font-size: 0;
}
.title {
  font-size: 0;
  display: inline-block;
  .iconfont {
    font-size: 40px;
    line-height: 90px;
    background: linear-gradient(to bottom right, #e8c9a0, #c59962);
    -webkit-background-clip: text;
    color: transparent;
    vertical-align: middle;
    display: inline-block;
    margin-right: 15px;
  }
  em {
    font-size: 33px;
    color: #333333;
    line-height: 90px;
    vertical-align: middle;
  }
}
.indexBook {
  background: #fff;
  border-bottom: 1PX solid #e1e1e1;
  padding-bottom: 36px;
}
.category {
  ul {
    margin-left: -8px;
    margin-right: -8px;
    overflow: hidden;
    li {
      float: left;
      padding: 0 8px;
      box-sizing: border-box;
      width: 33.3333%;
    }
  }
}
</style>
